import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=7756c207&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=ts"
export * from "./Reset.vue?vue&type=script&lang=ts"
import style0 from "./Reset.vue?vue&type=style&index=0&id=7756c207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7756c207",
  null
  
)

export default component.exports